import { render } from "./SubscribersList.vue?vue&type=template&id=79f70520&scoped=true"
import script from "./SubscribersList.vue?vue&type=script&lang=js"
export * from "./SubscribersList.vue?vue&type=script&lang=js"

import "./SubscribersList.vue?vue&type=style&index=0&id=79f70520&lang=scss&scoped=true"

import exportComponent from "/var/www/miniapp-sigur-admin-panel/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79f70520"],['__file',"src/assets/js/pages/Address/SubscribersList.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "79f70520"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('79f70520', __exports__)) {
    api.reload('79f70520', __exports__)
  }
  
  module.hot.accept("./SubscribersList.vue?vue&type=template&id=79f70520&scoped=true", () => {
    api.rerender('79f70520', render)
  })

}


export default __exports__